import * as ApiManager from './_manager'
import store from '../store';

export const analytics = {
    fetchEntityUserCount: (payload) => {
        return ApiManager.callApi(`/member/company/${store.getters['company/getSelected']}/analytics/fetchEntityUserCount`, payload);
    },

    fetchFilmWatchTime: (payload) => {
        return ApiManager.callApi(`/member/company/${store.getters['company/getSelected']}/analytics/fetchVideoWatchTime`, payload);
    },

    fetchEntityOverviewData:(payload) => {
        return ApiManager.callApi(`/member/company/${store.getters['company/getSelected']}/analytics/fetchEntityOverviewData`, payload);
    },

    fetchConsumerAnalyticsOnFilm:(payload) => {
        return ApiManager.callApi(`/member/company/${store.getters['company/getSelected']}/analytics/fetchConsumerAnalyticsOnFilm/${payload.consumerId}/${payload.filmId}`, payload);
    },

}
